// 관리자 콘솔 인증 세션 store.
// 사용자(손님) store 와 분리해 토큰 / 정책 / 영속 위치를 섞지 않는다.
// 관리자 콘솔은 PC 브라우저 전용이므로 localStorage 만 사용한다 (모바일/Capacitor 분기 없음).

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface AdminUser {
  id: string;
  loginId: string;
  role: "super" | "staff";
  displayName: string | null;
}

export interface AdminSession {
  accessToken: string;
  // 1-G 라운드 2 추가: 자동 refresh 인터셉터가 사용. 1-F 단계 세션에는 없을 수 있으므로 옵셔널.
  refreshToken?: string;
  refreshExpiresAt?: string;
  expiresAtSec: number;
  admin: AdminUser;
  // 첫 시드 로그인 직후 등 - 다음 로그인 전에 비밀번호를 변경해야 함을 알리는 플래그.
  changePasswordRequired: boolean;
}

interface AdminAuthStore {
  session: AdminSession | null;
  setSession: (session: AdminSession) => void;
  clearSession: () => void;
}

export const useAdminAuthStore = create<AdminAuthStore>()(
  persist(
    (set) => ({
      session: null,
      setSession: (session) => set({ session }),
      clearSession: () => set({ session: null }),
    }),
    {
      name: "oo-admin-auth",
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
